module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1288.594b8b38.png";